import React from "react";
import type { IconProp } from "@fortawesome/fontawesome-svg-core";

export function isGlobeIcon(icon: IconProp | undefined): boolean {
    if (!icon) {
        return false;
    }
    if (icon === "globe") {
        return true;
    }
    if (typeof icon === "string") {
        return icon.includes("globe");
    }
    if (Array.isArray(icon)) {
        return icon.some((part) => typeof part === "string" && part.includes("globe"));
    }
    return false;
}

interface SvgIconProps {
    className?: string;
}

export function ModernSelectGlobeIcon({ className }: SvgIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden="true"
        >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
            <path d="M2 12h20" />
        </svg>
    );
}

export function ModernSelectChevronDownIcon({ className }: SvgIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden="true"
        >
            <path d="m6 9 6 6 6-6" />
        </svg>
    );
}

export function ModernSelectChevronUpIcon({ className }: SvgIconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
            aria-hidden="true"
        >
            <path d="m6 15 6-6 6 6" />
        </svg>
    );
}
